import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo, useRef } from "react";
import { useRunPoolFunction } from "../../util/UsePoolFunction";
import { Contact3DBackgroundObjects } from "./Contact3DBackgroundObjects";
import { Contact3DThreeJSPlayer } from "./Contact3DThreeJSPlayer";
import { useContact3DPlayerList } from "../../../../game/contact3d/replicatedObjects/Contact3DPlayerRecords";
import { Pool } from "./Pool";
import { ThreeJSClue } from "./ThreeJSClue";
export const Contact3DThreeJSScene = () => {
    useRunPoolFunction();
    const playerRefs = [0, 1, 2, 3, 4, 5, 6, 7, 8].map(() => useRef());
    const playerList = useContact3DPlayerList();
    const playersWithApis = useMemo(() => {
        const result = Object.create(null);
        playerList.forEach((player, index) => { result[player.playerId] = Object.assign(Object.assign({}, player), { apiRef: playerRefs[index] }); });
        return result;
    }, [playerList]);
    return _jsxs(_Fragment, { children: [_jsx(Contact3DBackgroundObjects, {}), _jsx(Pool, {}), playerList.map((player, index) => _jsx(Contact3DThreeJSPlayer, { playerApiRef: playerRefs[index], record: player }, player.playerId)), _jsx(ThreeJSClue, { playersWithApis: playersWithApis })] });
};
//# sourceMappingURL=Contact3DThreeJSScene.js.map